import { shallowRef } from 'vue';
import NewAccountTour from '@/parts/objects/components/NewAccountTour.vue';
import TariffsTour from '@/parts/objects/components/TariffsTour.vue';
import PlacingVariantsTour from '@/parts/tariffs/components/PlacingVariantsTour.vue';
import ZeroPriceNote from '@/parts/tariffs/components/PricesAndRestrictions/ZeroPriceNote.vue';

const tours = {
  newAccountTour: NewAccountTour,
  tariffsTour: TariffsTour,
  tariffPlacingVariantsTour: PlacingVariantsTour,
  tariffZeroPriceNote: ZeroPriceNote,
};

type TourName = keyof typeof tours;

const activeTourComponent = shallowRef();

export const useTourStore = () => {
  const setActiveTour = (name: TourName) => {
    activeTourComponent.value = tours[name];
  };

  const closeActiveTour = () => {
    activeTourComponent.value = undefined;
  };

  return {
    activeTourComponent,
    setActiveTour,
    closeActiveTour,
  };
};
